import { apiFetch } from '../../lib/apiClient';
import type { Team, TeamRole } from '../../types/team';

/**
 * Raw UserTeamResponse (and tolerant of older/variant casings).
 * @see GET /users/{userId}/teams
 */
type UserTeamResponse = {
  id?: string;
  Id?: string;
  name?: string;
  Name?: string;
  role?: string;
  Role?: string;
};

export function listMyTeams(userId: string): Promise<Team[]> {
  return apiFetch<unknown>(`/users/${encodeURIComponent(userId)}/teams`).then(normalizeTeams);
}

function normalizeTeams(payload: unknown): Team[] {
  const rows = Array.isArray(payload) ? payload : [];
  return rows
    .map((row) => normalizeTeam(row))
    .filter((t): t is Team => t != null);
}

export function normalizeRole(value: unknown): TeamRole | null {
  if (typeof value !== 'string') return null;
  const v = value.trim().toLowerCase();
  if (v === 'strategist' || v === 'player') return v;
  return null;
}

function normalizeTeam(row: unknown): Team | null {
  if (!row || typeof row !== 'object') return null;
  const raw = row as UserTeamResponse;
  const id = raw.id ?? raw.Id;
  if (!id || typeof id !== 'string') return null;
  const name = raw.name ?? raw.Name;
  const role = normalizeRole(raw.role ?? raw.Role);
  // role is required by API; skip malformed rows rather than treat as player incorrectly
  if (!role) return null;
  return {
    id,
    name: typeof name === 'string' ? name : '',
    role,
  };
}
